import { render, staticRenderFns } from "./PickZonesModal.vue?vue&type=template&id=9a24a0fa&scoped=true&"
import script from "./PickZonesModal.vue?vue&type=script&lang=ts&"
export * from "./PickZonesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a24a0fa",
  null
  
)

export default component.exports